export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_fr.88b269c5ba9527a8.json"